/*
========================================================
STRIPE BILLING API
--------------------------------------------------------
Purpose:
- Frontend helper functions for calling billing routes
- Keeps billing fetch logic out of page components
========================================================
*/

export async function fetchBillingStatus() {
  const res = await fetch("/api/billing/status", {
    credentials: "include",
    headers: {
      ...(localStorage.getItem("x-tenant")
        ? { "x-tenant": localStorage.getItem("x-tenant") }
        : {}),
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Failed to load billing status");
  }

  return res.json();
}

export async function createCheckoutSession(plan) {
  const res = await fetch("/api/billing/create-checkout-session", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(localStorage.getItem("x-tenant")
        ? { "x-tenant": localStorage.getItem("x-tenant") }
        : {}),
    },
    body: JSON.stringify({ plan }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Failed to create checkout session");
  }

  return res.json();
}

export async function createCustomerPortalSession() {
  const res = await fetch("/api/billing/create-customer-portal-session", {
    method: "POST",
    credentials: "include",
    headers: {
      ...(localStorage.getItem("x-tenant")
        ? { "x-tenant": localStorage.getItem("x-tenant") }
        : {}),
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Failed to create customer portal session");
  }

  return res.json();
}
